export const keywordsConst = {
  ADD_NEW_KEYWORD_BEGIN: 'ADD_NEW_KEYWORD_BEGIN',
  ADD_NEW_KEYWORD_SUCCESS: 'ADD_NEW_KEYWORD_SUCCESS',
  ADD_NEW_KEYWORD_FAILED: 'ADD_NEW_KEYWORD_FAILED',
  FETCH_KEYWORDS_BEGIN: 'FETCH_KEYWORDS_BEGIN',
  FETCH_KEYWORDS_SUCCESS: 'FETCH_KEYWORDS_SUCCESS',
  FETCH_KEYWORDS_FAILED: 'FETCH_KEYWORDS_FAILED',
  SET_ADDED_KEYWORDS: 'SET_ADDED_KEYWORDS',
};
